import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const MistakeNotice = styled.div `
  display: flex;
  align-items: center;
  padding: ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.75')};
`;
export const UpgradeNotice = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.assistant.50')};
`;
